/* index.js */

"use strict";
const SteveDiffUtils = require("./diffutils/SteveDiffUtils");
const StevePromiseUtils = require("./promiseutils/StevePromiseUtils");

class SteveUtils {
    constructor() {}
    static getTimestamp(epoch) {
        let date = new Date(epoch);
        let datelocale = date.toLocaleDateString();
        let timelocale = date.toLocaleTimeString();
        let fullTimeString = datelocale + " " + timelocale;
        return fullTimeString;
    }

    static b64EncodeUnicode(str) {
        let encodedUri = encodeURIComponent(str);
        let b64 = btoa(encodedUri);
        return b64;
    }

    static b64DecodeUnicode(str) {
        let b64Removed = atob(str);
        let plainText = decodeURIComponent(b64Removed);
        return plainText;
    }

    static b64Encode(str) {
        return btoa(str);
    }

    static b64Decode(str) {
        return atob(str);
    }

    static arrayBuffer2String(buf) {
        return String.fromCharCode.apply(null, new Uint16Array(buf));
    }

    static string2ArrayBuffer(str) {
        let buf = new ArrayBuffer(str.length * 2); // 2 bytes for each char
        let bufView = new Uint16Array(buf);
        // let bufView = new Uint16Array(buf);
        for (let i = 0, strLen = str.length; i < strLen; i++) {
            bufView[i] = str.charCodeAt(i);
        }
        return buf;
    }

    /**
     * Buffer to ArrayBuffer
     * @param buffer - Buffer.toJSON "data" value
     * @returns {ArrayBuffer}
     */
    static bufferToArrayBuffer(buffer) {
        let ab = new ArrayBuffer(buffer.length);
        let view = new Uint8Array(ab);
        for (let i = 0; i < buffer.length; ++i) {
            view[i] = buffer[i];
        }
        return ab;
    }

    static get diff() {
        return SteveDiffUtils;
    }
    static get promise() {
        return StevePromiseUtils;
    }
}
module.exports = SteveUtils;
